import React from 'react'
import Markdown from '../Markdown'
import { toSlug } from 'ak-react-utils'
import { layoutConfigFor } from '../../utils'
import useDomainLayoutsQuery from '../../hooks/useDomainLayoutsQuery'

const SectionImagePlain = ({ section }) => {
  const {
    domain: {
      domain_settings
    }
  } = useDomainLayoutsQuery()

  const { section_image_config } = layoutConfigFor(section.parent.layout, domain_settings)

  const imageUrl = section.image_url

  return (
    <section className='section-image-plain mb-5 clearfix'>
      <img
        className='section-image'
        width={section_image_config.width}
        height={section_image_config.height}
        src={imageUrl}
        alt=''
      />
      <h2 id={ toSlug(section.headline) } className='section-headline'>
        { section.headline }
      </h2>

      {section.body && (
        <div className='section-body'>
          <Markdown>
            { section.body }
          </Markdown>
        </div>
      )}
    </section>
  )
}

export default SectionImagePlain
